// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.travel-expenses__description[data-v-73012671] {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.travel-expenses__note[data-v-73012671] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
